<template>
  <div class="customer-address" :class="{ default: address.default }">
    <div class="customer-address-container">
      <div class="customer-address-content" :class="{ default: address.default }">
        <div class="customer-address-content__label">
          <p>{{ address.name ? address.name : '' }}{{ address.default ? '*' : '' }}</p></div>
        <div class="customer-address-content__address">
          <p>{{ address.address1 }},
            {{ address.address2 ? address.address2 + ', ' : '' }}{{ address.city }}, {{ address.state }} {{
            address.zip
          }}</p>
        </div>
      </div>
    </div>

    <div class="customer-address-buttons-container">
      <button type="button" @click="editAddress" class="btn btn--primary">
        Edit
      </button>
      <button @click="showDeleteAddress" type="button" class="btn btn--warning">
        Remove
      </button>
    </div>

    <div class="full-page-confirmation" v-if="isDeleteMode">
      <div v-if="!showSuccessMsg">Delete Address?</div>
      <div v-else>
        Address Deleted
      </div>
      <div class="full-page-confirmation__buttons" v-if="!showSuccessMsg">
        <button type="button" @click="deleteAddress" class="btn btn--primary">
          Confirm
        </button>
        <button @click="cancelDelete" class="btn btn--warning" type="button">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Customer addresses',
  props: {
    customerAddressesCount: {
      type: Number,
      default: 0
    },
    address: {
      type: Object,
      default() {
        return {}
      }
    },
    customerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isDeleteMode: false,
      showSuccessMsg: false
    }
  },
  emits: ["customerEditAddress", "customerDeleteAddress", "customerCannotDeleteAddress"],
  methods: {
    showDeleteAddress() {
      if(this.customerAddressesCount > 1) {
        this.isDeleteMode = true;
      } else {
        this.$emit("customerCannotDeleteAddress");
      }
    },
    editAddress(){
      this.$emit('customerEditAddress', this.address)
    },
    deleteAddress() {
      api.deleteCustomerAddress(this.address.shopify_id, this.customerId).then(() => {
        this.showSuccessMsg = true;
        this.$emit('customerDeleteAddress', this.customerId);
        setTimeout(()=>{
          this.showSuccessMsg = false;
          this.isDeleteMode = false
        }, 2000);
      }).catch(() => {
        this.isDeleteMode = false;
      });
    },
    cancelDelete() {
      this.isDeleteMode = false;
    },
  }
}

</script>

<style scoped>
.customer-address {
  display: flex;
  margin: 0 0 20px 0;
}

.customer-address-content {
  white-space: pre-line;
  height: 100%;
  display: flex;
  white-space: pre;
}

.customer-address-content.default {
  font-weight: bold;
}

.customer-address-content__label {
  padding-right: .8125rem;
  height: 100%;
  border-right: 1px solid #E5E5E5;
  align-items: center;
  display: inherit;
  width: 90px;
}

.customer-address-content__label p {
  white-space: break-spaces;
  width: 90px;
  overflow: hidden;
}

.customer-address-content__address {
  padding-left: .8125rem;
  align-items: center;
  display: inherit;
  overflow: hidden;
  white-space: nowrap;
}

.customer-address-content__address p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.customer-address-container {
  max-width: 75%;
  min-width: 75%;
  margin-right: 10px;
  border: 1px solid #E5E5E5;
  background-color: white;
  position: relative;
  padding: 0 8px;
}

.customer-address-buttons-container {
  width: 100%;
}

.full-page-confirmation {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: #F7F7F7;
  z-index: 1;
  flex-direction: column;
  text-align: center;
}

.full-page-confirmation__buttons {
  position: absolute;
  bottom: 34px;
  width: 80%;
  display: flex;
}

@media screen and (max-width: 992px) {
  .customer-address-container {
    min-width: 70%;
    margin-right: 10px;
  }

  .btn {
    min-width: 100px;
    max-height: 40px;
    margin: 0 5px;
  }

  .full-page-confirmation__buttons {
    display: block;
  }
}
</style>
